import { render, staticRenderFns } from "./editable-field.vue?vue&type=template&id=b8c467aa"
import script from "./editable-field.vue?vue&type=script&lang=js"
export * from "./editable-field.vue?vue&type=script&lang=js"
import style0 from "./editable-field.vue?vue&type=style&index=0&id=b8c467aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports